<template>
  <div id="summary-report" v-if="generatedTable">
    <div id="summary-report-container">
      <div v-if="!showTableOnly">
        <h2>Summary report</h2>
        <div class="summary-report-controls">
          <v-btn
            id="summary-report-btn"
            color="blue"
            dark
            @click="openSummaryReport()"
          >
            Open
          </v-btn>
          <v-btn
            id="summary-report-btn-close"
            color="error"
            v-if="summaryReportOpened && !gettingSummaryReportTable"
            @click="closeSummaryReport()"
          >
            Close
          </v-btn>
          <div class="summary-report-selection-form">
            <v-select
              id="summary-report-selector"
              :items="summaryReportPer"
              label="Per:"
              v-model="summaryReportSelectedPer"
              dense
              outlined
              hide-details
            ></v-select>
          </div>
          <div class="summary-report-Category-selection-form" style="Width:250px;">
            <v-select
              id="summary-report-category-selector"
              :items="summaryReportCategory"
              label="Category:"
              v-model="summaryReportSelectedCategory"
              dense
              outlined
              hide-details
              v-on:change="changeSummaryReportFilter($event, 'Product Category', true)"
            ></v-select>
          </div>
          <div>
            <span>Time frame:</span>
              <v-md-date-range-picker
                @change="handleSummaryReportTimeFrameChange"
              ></v-md-date-range-picker>
          </div>
        </div>
        <div v-if="summaryReportOpened">
          <div class="summary-in-new-window-control">
            <!-- <v-btn
              dark
              class="open-in-window"
              color="indigo"
              elevation="3"
              id="open-summary-table-in-window" 
              @click="triggerSummaryTableWindowOpen">
              <i class="fas fa-external-link-alt open-tbl-btn"></i>
              <span>&nbspOpen in new window</span>
            </v-btn> -->
            <v-btn
              dark
              class="open-in-window"
              color="indigo"
              elevation="3"
              id="open-summary-table-in-window">
              <download-excel :data="excelExportData">Download Excel</download-excel>
            </v-btn>
          </div>
        </div>
      </div>
      <div v-if="!showTableOnly && summaryReportOpened">
        <div class="columns-visibility-toggle-container" v-if="summaryReportOpened">
          <div class="toggles-header">
            <h3>Show/hide columns</h3>
            <button @click="toggleSummaryTogglesVisibility">
              <i v-if="summaryTogglesVisible" class="fa fa-angle-up toggles-visibility-control"></i>
              <i v-if="!summaryTogglesVisible" class="fa fa-angle-down toggles-visibility-control"></i>
            </button>
          </div>
          <div class="columns-visibility-toggle-list" v-if="summaryTogglesVisible">
            <div v-for="column in summaryReportAvailableColumns" :key="column.field" class="column-visibility-toggle">
              <v-checkbox
                v-model="summaryReportColumnsVisibilityComputed"
                :value="column.field"
                class="m-0"
                color="teal"
                density="compact"
                :label="column.name"
                hide-details
              ></v-checkbox>
            </div>
          </div>
        </div>
        <div>
          <v-data-table
            :headers="summaryReportHeadersFiltered"
            :items="summaryReportTableData"
            :item-key="summaryReportRowDataKey"
            :sort-by="[summaryReportRowDataKey]"
            :sort-desc="[true]"
            :custom-sort="customSort"
            :search="summaryReportSearch"
            :class="'elevation-2 ' + (isInWindowPortal ? 'my-1' : 'my-0')"
            :height="isInWindowPortal ? null : 'auto'"
            :items-per-page="itemsPerPage"
            :loading="gettingSummaryReportTable"
            :custom-filter="filterSummaryReport"
            :footer-props="{'items-per-page-options':[-1, 10, 20, 30, 50, 100]}"
            loading-text="Loading... Please wait"
            multi-sort
            dense
            fixed-header
            caption="Summary report table"
            ref="table"
          >
          <template v-for="hdr in summaryReportHeadersFiltered" v-slot:[`header.${hdr.value}`]="{ header }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{hdr.text}}</span>
                </template>
                <span>{{ hdr.text === 'Profit To Year'? hdr.tooltip : hdr.text }}</span>
              </v-tooltip>
            <v-text-field
            v-show="hdr.filterable === true"
            :v-model="filtersSummaryReport[`hdr.value`]"
            v-on:change="changeSummaryReportFilter($event, hdr)"
            dense
            hide-details
            append-icon="fa-search"
            solid
            class="px-4"
            clearable
            />
          </template>
          <template v-slot:[`item.ThisMonthSales`]="props" >
            <span v-if="(props.item.ThisMonthSales < props.item.ThisMonthLastYearSales)"><span style="color: red;">&#8595;&nbsp;</span></span>
            <span v-else-if="(props.item.ThisMonthSales > props.item.ThisMonthLastYearSales)"><span style="color: green;">&#8593;&nbsp;</span></span>
              {{  currencyFormatter(props.item[`ThisMonthSales`]) }}
            </template>
            <template v-slot:[`item.ThisMonthMargin`]="props" >
              <span v-if="(props.item.ThisMonthMargin < props.item.ThisMonthLastYearMargin)"><span style="color: red;">&#8595;&nbsp;</span></span>
              <span v-else-if="(props.item.ThisMonthMargin > props.item.ThisMonthLastYearMargin)"><span style="color: green;">&#8593;&nbsp;</span></span>
                {{  markupFormatter(props.item[`ThisMonthMargin`]) }} 
            </template>
             <template v-slot:[`item.ThisMonthProfit`]="props" >
              <span v-if="(props.item.ThisMonthProfit < props.item.ThisMonthLastYearProfit)"><span style="color: red;">&#8595;&nbsp;</span></span>
              <span v-else-if="(props.item.ThisMonthProfit > props.item.ThisMonthLastYearProfit)"><span style="color: green;">&#8593;&nbsp;</span></span>
                {{  currencyFormatter(props.item[`ThisMonthProfit`]) }} 
            </template>
             <template v-slot:[`item.ThisMonthLastYearSales`]="props" >
                {{  currencyFormatter(props.item[`ThisMonthLastYearSales`]) }}
            </template>
             <template v-slot:[`item.ThisMonthLastYearMargin`]="props" >
                {{  markupFormatter(props.item[`ThisMonthLastYearMargin`]) }}
            </template>
             <template v-slot:[`item.ThisMonthLastYearProfit`]="props" >
                {{  currencyFormatter(props.item[`ThisMonthLastYearProfit`]) }}
            </template>
             <template v-slot:[`item.YearToDateSales`]="props" >
              <span v-if="(props.item.YearToDateSales < props.item.LastYearSales)"><span style="color: red;">&#8595;&nbsp;</span></span>
              <span v-else-if="(props.item.YearToDateSales > props.item.LastYearSales)"><span style="color: green;">&#8593;&nbsp;</span></span>
                {{  currencyFormatter(props.item[`YearToDateSales`]) }}
            </template>
             <template v-slot:[`item.YearToDateMargin`]="props" >
              <span v-if="(props.item.YearToDateMargin < props.item.LastYearMargin)"><span style="color: red;">&#8595;&nbsp;</span></span>
              <span v-else-if="(props.item.YearToDateMargin > props.item.LastYearMargin)"><span style="color: green;">&#8593;&nbsp;</span></span>
                {{  markupFormatter(props.item[`YearToDateMargin`]) }}
            </template>
             <template v-slot:[`item.YearToDateProfit`]="props" >
              <span v-if="(props.item.YearToDateProfit < props.item.LastYearProfit)"><span style="color: red;">&#8595;&nbsp;</span></span>
              <span v-else-if="(props.item.YearToDateProfit > props.item.LastYearProfit)"><span style="color: green;">&#8593;&nbsp;</span></span>
                {{  currencyFormatter(props.item[`YearToDateProfit`]) }}
            </template>
             <template v-slot:[`item.LastYearSales`]="props" >
                {{  currencyFormatter(props.item[`LastYearSales`]) }}
            </template>
             <template v-slot:[`item.LastYearMargin`]="props" >
                {{  markupFormatter(props.item[`LastYearMargin`]) }}
            </template>
             <template v-slot:[`item.LastYearProfit`]="props" >
                {{  currencyFormatter(props.item[`LastYearProfit`]) }}
            </template>
            <template v-slot:[`body.append`]="{ headers }">
              <tr class="v-table__summary">
                <th class="title">
                   <span>
                      Total items:<br> {{ totalsLineData['itemsCnt'] }}
                   </span>
                </th>
                <th v-for="(header,i) in headers.slice(1)" :key="i" class="text-right">
                  <span v-if="!header.value.endsWith('Margin')">£{{ totalsLineData[header.value] }}</span>
                  <span v-else>{{ markupFormatter(totalsLineData[header.value]) }}</span>
                </th>
              </tr>
            </template>
          </v-data-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { sortItems } from 'vuetify/es5/util/helpers';

export default {
  data() {
    return {
      isInWindowPortal: false,
      space: ' ',
      filtersSummaryReport: {
        Category: '',
        Supplier: '',
        currentValue: '',
        currentCol: '',
        ThisPeriodSales: '',
        ThisPeriodMargin: '',
        ThisPeriodrofit: '',
        ThisPeriodLastYearSales: '',
        ThisPeriodLastYearMargin: '',
        ThisPeriodLastYearProfit: '',
        ThisMonthSales: '',
        ThisMonthMargin: '',
        ThisMonthProfit: '',
        ThisMonthLastYearSales: '',
        ThisMonthLastYearMargin: '',
        ThisMonthLastYearProfit: '',
        YearToDateMargin: '',
        YearToDateProfit: '',
        LastYearSales: '',
        LastYearMargin: '',
        LastYearProfit: '',
      },
      summaryReportColumnsVisibility: [],
      summaryReportOpened: false,
      summaryReportPer: ['category', 'supplier'],
      summaryReportCategory: ['All', 'Care Shop', 'Shop', 'Pharmacy Services'],
      summaryReportSelectedCategory: 'All',
      summaryReportSelectedPer: 'category',
      summaryReportSelectedTimeFrame: null,
      summaryTogglesVisible: false,
      itemsPerPage: 50,
      copyableDataKeys: ['isInWindowPortal', 'filtersSummaryReport', 'summaryReportColumnsVisibility', 'summaryReportOpened', 'summaryTogglesVisible', 'summaryReportSelectedPer', 'itemsPerPage'],
    };
  },
  computed: {
    ...mapState('products', [
      'generatedTable',
      'summaryReportTableData',
      'receivedSummaryReportTable',
      'summaryReportAggregateBy',
      'gettingSummaryReportTable',
      'summaryReportTableWindowOpen',
      'excelExportData',
      
    ]),
    summaryReportRowDataKey() {
      if (this.summaryReportAggregateBy === 'category') {
        return 'Product Category'
      } else if (this.summaryReportAggregateBy === 'supplier') {
        return 'Supplier'
      } else {
        return 'ProductID'
      }
    },
    summaryReportAvailableColumns() {
      let columns = new Array();
      for (const hdr of this.summaryReportHeaders) {
        const column = {
          name: hdr.text,
          field: hdr.value
        }
        columns.push(column);
      }
      return columns;
    },
    summaryReportColumnsVisibilityComputed: {
      get() {
        if (this.summaryReportColumnsVisibility.length == 0) {
          let visibility = [];
          for (const column of this.summaryReportAvailableColumns) {
            visibility.push(column.field);
          }
          return visibility;
        }
        return this.summaryReportColumnsVisibility;
      },
      set(value) {
        this.summaryReportColumnsVisibility = value;
      },
    },
    summaryReportHeaders() {
      const MS = 'ThisMonthSales';
      const MM = 'ThisMonthMargin';
      const MP = 'ThisMonthProfit';
      const MLastYS = 'ThisMonthLastYearSales';
      const MLastYM = 'ThisMonthLastYearMargin';
      const MLastYP = 'ThisMonthLastYearProfit';
      const YtoDateS = 'YearToDateSales';
      const YtoDateM = 'YearToDateMargin';
      const YtoDateP = 'YearToDateProfit';
      const LastYS = 'LastYearSales';
      const LastYM = 'LastYearMargin';
      const LastYP = 'LastYearProfit';
      let isSuperUser =  localStorage.getItem('SET_SUPERUSER') === 'true';
      const firstDateOfYear = new Date(new Date().getFullYear(), 0, 1).toDateString().replace(/^\S+\s/,'');
      const profitToYearText = firstDateOfYear +  ' to current Date';
      const selectedPeriodHdrs = [
        { text: 'Total £ sales this period', value: MS, filterable: true, filter: this.filterSimple, filterable: true, align: 'right' },
        { text: 'MKUP this period', value: MM, filterable: true, filter: this.filterSimple, filterable: true, align: 'right' },
        { text: 'Profit this period', value: MP, filterable: true, align: 'right' , visible : isSuperUser},
        { text: 'Total £ sales this period last year', value: MLastYS, filterable: true, align: 'right' },
        { text: 'MKUP this period last year', value: MLastYM , filterable: true, align: 'right' },
        { text: 'Profit this period last year', value: MLastYP, filterable: true, align: 'right', visible : isSuperUser },
      ]
      const unselectedPeriodHdrs = [
        { text: 'Total £ sales this Month', value: MS, filterable: true, filter: this.filterSimple, filterable: true, align: 'right' },
        { text: 'MKUP this month', value: MM, filterable: true, filter: this.filterSimple, filterable: true, align: 'right' },
        { text: 'Profit this month', value: MP, filterable: true, align: 'right', visible : isSuperUser },
        { text: 'Total £ sales this month last year', value: MLastYS, filterable: true, align: 'right' },
        { text: 'MKUP this month last year', value: MLastYM, filterable: true, align: 'right' },
        { text: 'Profit this month last year', value: MLastYP, filterable: true, align: 'right', visible : isSuperUser },
      ]
      const generalHdrs = [
        { text: 'Total £ sales year to date', value: YtoDateS, filterable: true, align: 'right' },
        { text: 'MKUP year to date', value: YtoDateM, filterable: true, align: 'right' },
        { text: 'Profit To Year', value: YtoDateP, filterable: true, tooltip: profitToYearText, align: 'right', visible : isSuperUser},
        { text: 'Total £ sales last year', value: LastYS, filterable: true, align: 'right' },
        { text: 'MKUP last year', value: LastYM, filterable: true, align: 'right' },
        { text: 'Profit last year', value: LastYP, filterable: true, align: 'right', visible : isSuperUser},
      ]
      const categoryHdr = { text: 'Category', value: 'Product Category', filterable: true, filter: this.filterSimple, filterable: true };
      const supplierHdr = { text: 'Supplier', value: 'Supplier', filterable: true, filter: this.filterSimple, filterable: true };

      let hdrs;
      (this.summaryReportSelectedTimeFrame === null) ? hdrs = unselectedPeriodHdrs : hdrs = selectedPeriodHdrs;
      if (this.summaryReportAggregateBy === 'category') hdrs = [categoryHdr, ...hdrs, ...generalHdrs];
      if (this.summaryReportAggregateBy === 'supplier') hdrs = [supplierHdr, ...hdrs, ...generalHdrs];
      return hdrs;
    },
    summaryReportHeadersFiltered() {
      let hdrs = [];
      this.summaryReportHeaders.forEach((hdr) => {
        if (this.summaryReportColumnsVisibilityComputed.includes(hdr.value) 
          && (hdr.visible == undefined || hdr.visible == true)){
          hdrs.push(hdr);
        }
      })
      return hdrs;
    },
    summaryReportSearch: {
      get() {
        return this.filtersSummaryReport.currentValue;
        /*
        if (this.filters.currentCol && this.filters[this.filters.currentCol]) {
          return this.filters[this.filters.currentCol] || '';
        }
        if (!this.filters.currentCol) return (this.filters.currentValue || ''); 
        return '';
        */
      },
      set(value) {
        this.filtersSummaryReport.currentValue = value;
      },
    },
    showTableOnly() {
      return (this.summaryReportTableWindowOpen && this.isInWindowPortal);
    },
    selectedPerPluralWordForm() {
      if (this.summaryReportAggregateBy === 'category') return 'categories';
      if (this.summaryReportAggregateBy === 'supplier') return 'suppliers';
      return '';
    }
  },
  methods: {
    openSummaryReport() {
      this.summaryReportOpened = true;
      this.$store.dispatch('products/getSummaryReportTable', {aggregateBy: this.summaryReportSelectedPer, timeFrame: this.summaryReportSelectedTimeFrame, currentLocationId:localStorage.getItem('selectedLocationId')});
    },
    closeSummaryReport() {
      this.summaryReportOpened = false;
    },
    handleSummaryReportTimeFrameChange(values) {
      this.summaryReportSelectedTimeFrame = values;
    },
    filterSummaryReport(value, search, item) {
      search = String(search);
      let nonEmptyFilterExists = false;
      for (var field in this.filtersSummaryReport) {
        if (['currentValue', 'currentCol'].includes(field)) continue;
        const filterVal = String(this.filtersSummaryReport[field]);
        if (filterVal === '' || filterVal === 'null') continue;
        const trueVal = String(item[field]);
        if(this.filtersSummaryReport.currentCategory && trueVal != 'undefined'){
          nonEmptyFilterExists = true;
            switch(this.filtersSummaryReport.currentCategory){
              case 'All' :
                    return true;
              case 'Care Shop' :
                    if (trueVal.toLowerCase().startsWith('x')) return true;
                    else  return false;
              case 'Shop' :
                    if (!trueVal.toLowerCase().startsWith('x')) return true;
                    else  return false;
              case 'Pharmacy Services' :
                    let pharmacyCatgeory = ['diagnostic', 'microsuction', 'flu private'];
                    if (pharmacyCatgeory.indexOf(trueVal.toLowerCase()) > 0) return true;
                    else  return false;
              default: 
                    return false;
            }
        }
        else if (filterVal) {
          nonEmptyFilterExists = true;
          if (!trueVal.toLowerCase().includes(filterVal.toLowerCase())) return false;
        }
      }
      if (search && !nonEmptyFilterExists) return false;
      return true;
    },
    changeSummaryReportFilter(val, header, isCategory = false) {
      this.filtersSummaryReport.currentValue = val;
      if(isCategory){
        header = this.summaryReportSelectedPer == 'supplier' ? 'Supplier' : header;
        this.filtersSummaryReport[header] = val;
        this.filtersSummaryReport.currentCol = this.summaryReportSelectedPer;
        this.filtersSummaryReport.currentCategory = val;
      }
      else{
        this.filtersSummaryReport[header.value] = val;
        this.filtersSummaryReport.currentCol = header.value;
        delete this.filtersSummaryReport.currentCategory;
      }
    },
    naturalCompare(a, b) {
      var ax = [], bx = [];

      a.replace(/(\d+)|(\D+)/g, function(_, $1, $2) { ax.push([$1 || Infinity, $2 || '']) });
      b.replace(/(\d+)|(\D+)/g, function(_, $1, $2) { bx.push([$1 || Infinity, $2 || '']) });
      
      while(ax.length && bx.length) {
          var an = ax.shift();
          var bn = bx.shift();
          var nn = (an[0] - bn[0]) || an[1].localeCompare(bn[1]);
          if(nn) return nn;
      }

      return ax.length - bx.length;
    },
    sortingFunc(el1, el2) {
      let a = String(el1).trim().toLowerCase().split(' ').join('0');
      let b = String(el2).trim().toLowerCase().split(' ').join('0');
      return this.naturalCompare(b, a);
    },
    customSort(items, sortBy, sortDesc, locale, customSorters) {
      const sorters = {
        'Product Category': this.sortingFunc,
        'Supplier': this.sortingFunc,
      }
      this.setTotalFooter(items);
      return sortItems(items, sortBy, sortDesc, locale, sorters);
    },
    setTotalFooter(items){
      //if(items.length == 0) return;
      const hdrsCnt = this.summaryReportHeaders.length;
      for (let fieldIx=1; fieldIx < hdrsCnt; fieldIx++) {
        const hdr = this.summaryReportHeaders[fieldIx];
        if (!hdr) return;
        const field = hdr.value;
        let totalValue = 0;
        if (hdr.text.startsWith('MKUP')) {
            // calc avg markup
            let sellingColumn = '';
            let profitColumn = '';

            switch (hdr.value) {
              case 'ThisMonthMargin':
                sellingColumn = 'ThisMonthSales';
                profitColumn = 'ThisMonthProfit';
                break;
              case 'ThisMonthLastYearMargin':
                sellingColumn = 'ThisMonthLastYearSales';
                profitColumn = 'ThisMonthLastYearProfit';
                break;
              case 'YearToDateMargin':
                sellingColumn = 'YearToDateSales';
                profitColumn = 'YearToDateProfit'
                break;
              case 'LastYearMargin':
                sellingColumn = 'LastYearSales';
                profitColumn = 'LastYearProfit';
                break;
            }
            let totalSellingValue = this.currencyFormatter(items.reduce((partialSum, item) => partialSum + parseFloat(item[sellingColumn]), 0));
            let totalProfitValue = this.currencyFormatter(items.reduce((partialSum, item) => partialSum + parseFloat(item[profitColumn]), 0));
            let totalcost = totalSellingValue - totalProfitValue;
            totalValue = totalProfitValue > 0 ? ( totalProfitValue / totalcost ) : 0;
        } else {
          /* // calc sum
           items.forEach(obj => {
            console.log('totalValue' +  totalValue);
              console.log('current value' +  totalValue);
              totalValue += parseFloat( obj[field] );
              console.log('totalValue' +  totalValue);
          });  */
          totalValue = this.currencyFormatter(items.reduce((partialSum, item) => partialSum + parseFloat(item[field]), 0));
        }
        this.totalsLineData[field] = Number(totalValue).toLocaleString();
      }
      this.totalsLineData['itemsCnt'] = items.length;
    },
    totalsLineData() {
      let totals = {};
      const items = this.summaryReportTableData;
      const hdrsCnt = this.summaryReportHeaders.length;
      for (let fieldIx=1; fieldIx < hdrsCnt; fieldIx++) {
        const hdr = this.summaryReportHeaders[fieldIx];
        if (!hdr) return;
        const field = hdr.value;
        let totalValue;
        if (hdr.text.startsWith('MKUP')) {
          // calc avg markup
          totalValue = this.markupFormatter((items.reduce((partialSum, item) => partialSum + parseFloat(item[field]), 0) * 100) / items.length / 100);
        } else {
          // calc sum
          /* for( var obj in items ) {
            if( items.hasOwnProperty( field ) ) {
              console.log('totalValue' +  totalValue);
              console.log('current value' +  totalValue);
              totalValue += parseFloat( obj[field] );
              console.log('totalValue' +  totalValue);
            }
          } */
 
          totalValue = this.currencyFormatter(items.reduce((partialSum, item) => partialSum + parseFloat(item[field]), 0));
        }
        totals[field] = Number(totalValue).toLocaleString();
      }
      totals['itemsCnt'] = items.length;
      return totals;
    },
    triggerSummaryTableWindowOpen() {
      if (this.summaryReportTableWindowOpen) {
        this.$store.dispatch('products/closeSummaryTableWindow');
        setTimeout(() => this.$store.dispatch('products/openSummaryTableInWindow'), 1000)
      } else {
        this.$store.dispatch('products/openSummaryTableInWindow');
      }
    },
    toggleSummaryTogglesVisibility() {
      this.summaryTogglesVisible = !this.summaryTogglesVisible;
    },
    calcSum(items, fieldIx) {
      if (!this.summaryReportHeaders[fieldIx]) return;
      const field = this.summaryReportHeaders[fieldIx].value;
      return Math.round(items.reduce((partialSum, item) => partialSum + item[field], 0));
    },
    calcAvgMkup(items, fieldIx) {
      if (!this.summaryReportHeaders[fieldIx]) return;
      const field = this.summaryReportHeaders[fieldIx].value;
      return Math.round((items.reduce((partialSum, item) => partialSum + item[field], 0) * 100) / items.length) / 100;
    },
    currencyFormatter(value){
      return parseFloat(value).toFixed(2);
    },
    markupFormatter(value){
      return parseFloat(value).toFixed(3);
    },
  }
};
</script>

<style>

.summary-report-table {
  height: 1000px;
}

.summary-report-controls {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
}

#summary-report-btn, #summary-report-btn-close {
  height: 40px;
  width: 70px;
}

#summary-report-btn, #summary-report-btn-close, .summary-report-selection-form {
  margin-right: 30px;
}

.summary-report-Category-selection-form {
    width:250px;
}

#summary-report-btn {
  margin-right: 20px;
}

#summary-report {
  margin-top: 0;
  margin-bottom: 20px;
}

/*
#summary-report h3 {
  margin-top: 25px;
  margin-bottom: 10px;
}
*/

.summary-report-table th .header-content {
  white-space: normal;
}

.summary-table-total-rows {
  text-align: right;
  margin-top: 10px;
  margin-bottom: -30px;
}

.summary-report-cols-visibility-toggles-container .column-visibility-toggle {
  display: block;
  width: auto;
  margin-right: 15px;
}

#summary-report .v-table__summary th span {
  font-size: 12pt !important;
}

.v-table__summary {
  height: 60px;
  position: sticky;
  bottom: 0;
  background: #fff;
}

#summary-report .v-table__summary th {
  border-top: 1px solid rgba(0,0,0,0.9) !important;
  line-height: 1.15;
}

.products-table-section .v-data-table__wrapper {
  max-height: 1000px;
}


.summary-in-new-window-control {
  margin-bottom: 18px;
}


</style>



// WEBPACK FOOTER //
// src/components/SummaryReportTable.vue